// extracted by mini-css-extract-plugin
export default {"text":"SpaceStarter_text__SCDUF"};